/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/8/2023
 */

import {asArray, isObject} from "@/utils/helpers.js";
import DbBaseObject from "@shared/DbBaseObject.js";

export default class ShareableItem extends DbBaseObject {

	createdById: string = null
	createdByName: string = null
	sharedWithIds: string[] = []


	constructor(options) {
		super(options);
	}

	setCreatedBy(id, name){
		if(isObject(id) && id.id && id.name){
			name = id.name
			let myIdForOwner = typeof id.getMyIdForOwner === "function" ? id.getMyIdForOwner() : null
			id =  myIdForOwner || id.id
		}
		this.removeSharedWithById(this.createdById)
		this.createdById = id
		if(name){
			this.createdByName = name
		}
		this.addSharedWithById(this.createdById)
	}

	addSharedWithById(ids){
		if(!ids || !this.sharedWithIds || !this.sharedWithIds.indexOf){
			return false
		}
		ids = asArray(ids)

		let res = false
		for(let id of ids){
			let index = this.sharedWithIds.indexOf(id)
			if(id && index < 0) {
				this.sharedWithIds.push(id)
				res = true
			}
		}
		return res
	}

	removeSharedWithById(ids){
		if(!ids || !this.sharedWithIds || !this.sharedWithIds.indexOf){
			return
		}
		if(!Array.isArray(ids)){
			ids = [ids]
		}
		let res = false
		for(let id of ids){
			let index = this.sharedWithIds.indexOf(id)
			if(index >= 0) {
				this.sharedWithIds.splice(index, 1)
				res = true
			}
		}
		return res
	}
}
